/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/kycform.config.json";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_PROFILE } from "../graphql";
import { VApplication } from "../../../application";

import { StorageModule } from "@vlinder-web/storage-module-react";

const lookup = require("country-code-lookup");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface IKYCFormDataMethods extends IPluginMethodMap {
  getKYCFormDataContent(args: any): any;
}

export class KYCFormDataService implements IAgentPlugin {
  readonly methods: IKYCFormDataMethods;
  constructor() {
    this.methods = {
      getKYCFormDataContent: this.getProps.bind(this),
    };
  }
  
  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageSrv = StorageModule.getInstance();
    
    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_PROFILE,
          variables: { input: {} },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getMyProfile) {
          let _res = res?.data?.getMyProfile;
          storageSrv.set("myProfile", _res, "session");
          const KYCformData = _res;
          console.log("KYCformData---->", KYCformData);
          return {
            FIELDS: this.getFields(_res),
            layout: config?.layout,
            validatorConfig: config?.validatorConfig,
            kycData: _res?.kyc || [],
            policyHolder: {
              firstName: _res?.firstName,
              lastName: _res?.lastName,
              email: _res?.email,
              telephone: _res?.primaryContactNo,
              streetAddress: _res?.address?.addressLine1,
              city: _res?.address?.city,
              country: _res?.address?.country
                ? lookup.byIso(_res?.address?.country)?.country
                : "-",
            },
            
           
            kycSubmitted: _res?.kycSubmitted,
            vuid: _res?.vuid,
          };
        }
      }
    } catch (err: any) {
      console.log(`Sign In user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
    return { ...(config || {}) };
  }

  // private getFields(res: any) {
  //   let filterFields = config?.filterIds ? [...config.filterIds] : [];
  //   if (res?.kycSubmitted) {
  //     let _temp1 = res.kyc?.find((i) => i?.type === "ADDRESS_PROOF");
  //     let _temp2 = res.kyc?.find((i) => i?.type === "ID_PROOF");

  //     if (!_temp1) {
  //       if (!filterFields.includes("addressProofType")) {
  //         filterFields.unshift("addressProofType");
  //       }
  //     }
  //     if (!_temp2) {
  //       if (!filterFields.includes("idProofType")) {
  //         filterFields.unshift("idProofType");
  //       }
  //     }
  //     filterFields = Array.from(new Set(filterFields));
  //   }
  //   const filteredArray = config?.FIELDS?.filter((i) =>
  //     filterFields.includes(i.compProps?.id)
  //   );
  //   return filteredArray || [];
  // }



  private getFields(res: any) {
  let filterFields = config?.filterIds ? [...config.filterIds] : [];

  filterFields = filterFields.filter(
    (id) => id !== "idProofType" && id !== "addressProofType"
  );

  const filteredArray = config?.FIELDS?.filter((i) =>
    filterFields.includes(i.compProps?.id)
  );

  return filteredArray || [];
}

}
